import { render, staticRenderFns } from "./MiniParametersTable.vue?vue&type=template&id=1f917e6c&"
import script from "./MiniParametersTable.vue?vue&type=script&lang=js&"
export * from "./MiniParametersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports